var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-page container"},[_c('n-card',[_c('n-table',{attrs:{"data":_vm.data,"columns":_vm.columns,"loading":_vm.$var('load')},scopedSlots:_vm._u([{key:"name",fn:function(ref){
var item = ref.item;
return [_vm._v("\n        /"+_vm._s(item.name)+"\n      ")]}},{key:"isActive",fn:function(ref){
var item = ref.item;
return [_vm._v("\n        "+_vm._s(item.isActive ? 'Отображается' : 'Скрыта')+"\n      ")]}},{key:"tools",fn:function(ref){
var item = ref.item;
return [_c('n-button',{on:{"click":function($event){return _vm.change(item)}}},[_vm._v(_vm._s(item.isActive ? 'Скрыть' : 'Отобразить'))])]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }